import { CLINIC } from "@/data/content";
import { Link } from "react-router-dom";
import { Instagram, Youtube, MessageCircle, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[hsl(var(--primary-dark))] text-white pt-16 md:pt-24 pb-8" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-5 md:px-12">
        <div className="grid grid-cols-12 gap-6 md:gap-8">
          <div className="col-span-12 md:col-span-4">
            <img src="/assets/logo.png" alt="Calm Dentistry & Cosmetology" className="h-12 w-auto mb-4 brightness-0 invert" />
            <p className="text-white/75 leading-relaxed text-[14px] md:text-[15px] max-w-sm">Gentle, modern dentistry in Andheri East & Powai — with Dr Raksha Shetty and a small, unhurried team.</p>
            <a href={`tel:${CLINIC.phoneDial[0]}`} className="btn-pill mt-6 inline-flex" style={{ background: "hsl(var(--accent))", color: "hsl(var(--primary-dark))" }}>
              Call {CLINIC.phones[0]} <span className="arrow" style={{ background: "white", color: "hsl(var(--primary-dark))"}}><ArrowUpRight size={14}/></span>
            </a>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="text-[12px] uppercase tracking-widest text-white/60 mb-4">Visit</div>
            <p className="text-[14px] text-white/85 leading-relaxed">{CLINIC.address}</p>
            <div className="text-[12px] text-white/60 mt-4">{CLINIC.hours}</div>
          </div>
          <div className="col-span-6 md:col-span-2">
            <div className="text-[12px] uppercase tracking-widest text-white/60 mb-4">Explore</div>
            <div className="flex flex-col gap-2 text-[14px]">
              <a href="/#story" className="hover:text-[hsl(var(--accent))]">About</a>
              <a href="/#services" className="hover:text-[hsl(var(--accent))]">Services</a>
              <Link to="/blog" className="hover:text-[hsl(var(--accent))]">Journal</Link>
              <a href="/#find" className="hover:text-[hsl(var(--accent))]">Contact</a>
            </div>
          </div>
          <div className="col-span-12 md:col-span-3">
            <div className="text-[12px] uppercase tracking-widest text-white/60 mb-4">Connect</div>
            <div className="flex flex-col gap-2 text-[14px]">
              <a href={`mailto:${CLINIC.email}`} className="hover:text-[hsl(var(--accent))] break-all">{CLINIC.email}</a>
              {CLINIC.phones.map((p, i) => <a key={p} href={`tel:${CLINIC.phoneDial[i]}`} className="hover:text-[hsl(var(--accent))]">{p}</a>)}
            </div>
            <div className="flex gap-3 mt-6">
              <SocialIcon href="https://www.youtube.com/channel/UCS2CtonlMILi2gLnBEcy3Zw"><Youtube size={16}/></SocialIcon>
              <SocialIcon href="https://instagram.com/calmdentistry"><Instagram size={16}/></SocialIcon>
              <SocialIcon href={CLINIC.whatsapp}><MessageCircle size={16}/></SocialIcon>
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 pt-6 border-t border-white/15 flex flex-col md:flex-row justify-between items-start md:items-center gap-3 text-[11px] md:text-[12px] text-white/60">
          <div>© {new Date().getFullYear()} Calm Dentistry & Cosmetology. All rights reserved.</div>
          <div>Serving Andheri East · Powai · Marol · Saki Vihar · Sakinaka</div>
        </div>
      </div>
    </footer>
  );
}

function SocialIcon({ href, children }) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[hsl(var(--accent))] hover:text-[hsl(var(--primary-dark))] flex items-center justify-center transition-colors">
      {children}
    </a>
  );
}
